import React, { Suspense } from "react";
import { HomeLoading } from "@/components/home-loading.tsx";
import { Outlet } from "react-router-dom";

export const SettingsLayout = () => {
  return (
    <Suspense
      fallback={
        <div className="w-full flex justify-center pt-16 px-4">
          <div className="w-full flex-1 max-w-[740px] flex flex-col gap-8">
            <HomeLoading />
          </div>
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
};
